var map = {
	"./bash-icon.png": "6682",
	"./css-icon.png": "62fd",
	"./html-icon.png": "e650",
	"./jquery-icon.png": "280c",
	"./js-icon.png": "3d8c",
	"./logo.png": "cf05",
	"./mysql-icon.png": "d85f",
	"./perl-icon.png": "47c4",
	"./php-icon.png": "d3f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";